<template>
    <div class="c-list overflow-scroll">
        <div v-if="caption !== '' && (options.headerStyle === '1' || options.headerStyle === undefined)" slot="header">
            {{caption}}
            <div v-if="subCaption !== ''" class="small text-muted">{{subCaption}}</div>
            <div class="card-header-actions pull-right">
                <slot name="cardTableHeaderActions"></slot>
            </div>
        </div>

        <div class="mb-4" v-if="caption !== '' && options.headerStyle === '2'">
            <h5 class="card-title mb-0">{{caption}}</h5>
            <div v-if="subCaption !== ''" class="small text-muted">{{subCaption}}</div>
            <div class="card-header-actions">
                <slot name="cardTableHeaderActions"></slot>
            </div>
        </div>

        <Table
                :onRowClick="onRowClick"
                :onColumnClick="onColumnClick"
                :onCellClick="onCellClick"
                :options="options"
                :onPageClick="onPageClick"
                :pagination="pagination"
                :rows="rows"
                :columns="columns" />
    </div>
</template>
<script>
    import CardTable from './CardTable'
    export default {
        extends: CardTable,
        name: 'List',
        components: {
            CardTable
        },
        props: {
            actions: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            rows(val) {
                this.dataRows = val
                this.setActions()
            }
        },
        mounted() {
            this.dataRows = this.rows
            this.dataActions = this.actions
        },
        data: function () {
            return {
                dataRows: [],
                dataActions: []
            }
        },
        methods: {
            addAction(key, callBack, columnLabel, value, columnClasses, columnStyles, position) {
                if (position === undefined) {
                    position = 'right'
                }
                let action = {
                    columnLabel: columnLabel,
                    key: key,
                    columnClasses: columnClasses,
                    columnStyles: columnStyles,
                    value: value,
                    callBack: callBack,
                    position: position
                }
                this.dataActions.push(action)
            },
            setActions() {
                for(let action in this.dataActions) {
                    action = this.dataActions[action]
                    if (action.key !== undefined) {
                        let columnIsExist = Core.Array.findByKey(this.dataColumns, 'key', action.key)
                        if (!columnIsExist) {
                            let column = {
                                label: action.columnLabel,
                                key: action.key,
                                classes: action.columnClasses,
                                styles: action.columnStyles
                            }
                            if (action.position === 'left') {
                                this.dataColumns.unshift(column)
                            } else {
                               this.dataColumns.push(column)
                            }
                        }
                        for(let rowIndex in this.dataRows) {
                            if (this.dataRows[rowIndex][action.key] === undefined || this.dataRows[rowIndex][action.key] == true) {
                                let row = {
                                    value: action.value,
                                    callBack: action.callBack
                                }
                                this.dataRows[rowIndex][action.key] = row
                            }
                        }
                    }
                }
            }
        }
    }
</script>

